import axios from "axios";

const adManagerbackend = axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_BACKEND_AD_MANAGER
      : process.env.REACT_APP_BACKEND_AD_MANAGER_DEV,
});

adManagerbackend.interceptors.request.use(
  (config) => {
    let token = "";
    token = sessionStorage.getItem("token");
    if (!token) token = localStorage.getItem("token");
    if (token) config.headers = { Authorization: `Bearer ${token}` };
    return config;
  },
  (error) => Promise.reject(error)
);

export default adManagerbackend;
